/***************************************************************************
* リサイズ時のtransitionを無効化 
***************************************************************************/

// リサイズ時のCSS transitionを無効化するクラス
const disableResizeTransition = () => {
  const body = document.querySelector('body');
  body.classList.add('resize-transition-stopper');
}

// リサイズ後のCSS transition を有効化するクラス
const enableCssTransition = () => {
  const body = document.querySelector('body');
  body.classList.remove('resize-transition-stopper');
}

// リサイズ処理の間引き
let resizeTimer;

window.addEventListener('resize', () => {
  // リサイズ開始時にtransitionを無効化する
  disableResizeTransition();

  // リサイズ中の処理を間引く
  clearTimeout(resizeTimer);

  // リサイズ終了時にtransitionを有効化する
  resizeTimer = setTimeout(() => {
    enableCssTransition();
  }, 300);
});